export default __webpack_public_path__ + "static/images/57e55bf1d2a6ac1a0f5e942553e38b76.svg";